<template>
    <div class="d-flex flex-column flex-fill centerArea">
        <DefaultToolbar />
        <CanvasComponent />
      
    </div>
  </template>
  
  <script>
import DefaultToolbar from "../Canvas/Toolbar/DefaultToolbar.vue"
import CanvasComponent from "../Canvas/Canvas.vue"

  export default {
    name: 'CenterArea',
    props: {
      msg: String,
      view:String
    },
    components:{
        DefaultToolbar,
         CanvasComponent
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.centerArea{
    background-color: rgb(238 240 242);
}

  </style>
  